import { render, staticRenderFns } from "./ChartBankMovements.vue?vue&type=template&id=340f23bd"
import script from "./ChartBankMovements.vue?vue&type=script&lang=js"
export * from "./ChartBankMovements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports